import EditBulkCoupon from './EditBulk';

export default EditBulkCoupon;
